import React from 'react';

import NumberInput from '@/components/NumberInput';

import { RatingLevelFormFieldProps } from './types';

function RatingLevelFormField(props: RatingLevelFormFieldProps) {
  const { disabled, value, onChange } = props;

  return (
    <NumberInput
      canBeEmpty
      className="w-full"
      disabled={disabled}
      max={10}
      min={1}
      size="medium"
      value={value}
      onChange={onChange}
    />
  );
}

export default RatingLevelFormField;
